module.exports = __webpack_public_path__ + "app-static/img/sqlp.0045002e.png";